import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MenuService } from 'src/app/Service/application-menu/menu.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { menuModel } from 'src/app/ViewModel/ApplicationMenu.Model';

@Component({
  selector: 'app-edit-menu',
  templateUrl: './edit-menu.component.html',
  styleUrls: ['./edit-menu.component.css']
})
export class EditMenuComponent implements OnInit {

  public data: any| menuModel[];

  constructor(public _notificationService: NotificationService, @Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<EditMenuComponent>, private menuService: MenuService) {
    this.data = this._data;
  }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

  postData() {
    if (!this.data['displayName']) {
      this._notificationService.showToast("Menu name is required", 'Warning');
      return;
    }
    if (!this.data['icon']) {
      this._notificationService.showToast("Menu icon is required", 'Warning');
      return;
    }
    if (!this.data['routeUrl']) {
      this._notificationService.showToast("Menu URI is required", 'Warning');
      return;
    }
    if (!this.data['menuOrder']) {
      this._notificationService.showToast("Menu order is required", 'Warning');
      return;
    }
    this.menuService.postApplicationMenulist(this.data).subscribe(data => {
      if (data["successCode"] == 200) {
        this._notificationService.showToast(data["successMessage"], "Success");
        this.closeDialog();
      }
      else {
        this._notificationService.showToast(data["successMessage"], "Warning")
      }
    });
  }

}
